<div [class.sidebar-is-opened]="isOpened">
  <div id="mySidebar" class="sidebar">
    <div class="container-menu">
      <div class="logofgc">
        <img src="../../../../assets/logos/fgc-logo.svg" alt="logo" />
      </div>
      <button type="button" class="closebtn" (click)="closeNav()">×</button>
      <button class="dropdown-btn spg-btn">
        SPG
        <i class="fa fa-caret-down"></i>
      </button>
      <div class="dropdown-container">
        <button class="dropdown-btn pd-btn">
          Pagamento Decendial
          <i class="fa fa-caret-down"></i>
        </button>
        <div class="dropdown-container">
          <a *ngIf="userHasAcessToResource(3085)" href="/#/spg/relatorio-pagamento-decendial" class="pagamento-btn">
            <img src="../../../../assets/icons/gerar-remessa.svg" />
            Relatório Posição de Pagamento Decendial
          </a>
        </div>
      </div>
    </div>

    <div class="ms-auto p-3" (click)="logout()">
      <a href="/"><i class="fas fa-sign-out-alt"></i> Sair</a>
    </div>
  </div>

  <div id="main">
    <button class="openbtn" id="openSidebar" (click)="openNav()">☰</button>
    <ng-content></ng-content>
  </div>
</div>
